module.exports = __webpack_public_path__ + "static/media/gb13.fcf04ba5.png";